import {makeAutoObservable} from "mobx";

export default class PriorityStore {
    priority = [
        {id: 1, name: 'Не важный'},
        {id: 2, name: 'Важный'},
        {id: 3, name: 'Сильно важный'},
        {id: 4, name: 'Критический'}
    ]
    constructor() {
        makeAutoObservable(this)
    }

    // setTask(priority) {
    //     this.priority = priority
    // }

}